module.exports = __webpack_public_path__ + "static/img/yundun.b2703d56.png";